import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { _EXIST_ERROR } from '../../data/store/ui/ui.selectors';
import { map } from 'rxjs/operators';

export const errorGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router);
  return store.select(_EXIST_ERROR).pipe(
    map(status => {
      if (status) {
        return true;
      }
      return router.createUrlTree(['/']);
    })
  );
};
